import React from "react";

function AboutBreak() {
    return(
        <div>
        <div>
          <img className="techDesk" src="./images/tech-desk.png" alt="" data-aos="fade-left" data-aos-duration="700"/>
          <hr className="line" />
        </div>
        <hr className="line-bottom" />
      </div>
    );
}

export default AboutBreak;